import { useRef } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { ChartContainer } from '../../../../../../common/chart/chartContainer'
import Area from '../../../../../../common/chart/chartContainer/Area'
import Line from '../../../../../../common/chart/chartContainer/Line'
import { Element } from '../../../../../../common/html/element'
import { getUnique } from '../../../../../../helpers/common'
import { formatVal } from '../../../../../../helpers/value'

const ChartRight = ({ data, propsChart }) => {
  const chartId = useRef(getUnique())
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <div className="h100 dFlex">
      <div className="h100 w75 flexColumn">
        <div className="fw600">
          <Translate value={propsChart.title} />
        </div>
        <ChartContainer
          chartId={chartId.current}
          data={data}
          margin={{ top: 16, left: 0, bottom: 0, right: 0 }}
          width="100%"
          height="100%"
          xAxis={[
            {
              dataKey: propsChart.xAxisKey,
              padding: { left: 22, right: 22 },
              type: 'category',
              tickMargin: 3,
              height: 18,
              tickFormatter: (year) => '‘' + String(year).slice(2, 4),
            },
          ]}
          yAxis={[
            {
              yAxisId: 'left',
              dataKeys: [propsChart.line.dataKey, propsChart.area.dataKey],
              isLineChart: true,
              hide: true,
            },
          ]}
          tooltip={{
            schema: {
              content: [
                {
                  dataKey: propsChart.line.dataKey,
                  label: propsChart.line.label,
                  formatValue: (value) => formatVal(value * 100, locale) + '%',
                },
                {
                  dataKey: propsChart.area.dataKey,
                  label: propsChart.area.label,
                  formatValue: (value) => formatVal(value * 100, locale) + '%',
                },
              ],
            },
          }}
        >
          <Area
            yAxisId="left"
            dataKey={propsChart.area.dataKey}
            fill={propsChart.area.color}
            dot={{ fill: propsChart.area.dotColor }}
          />
          <Line
            yAxisId="left"
            dataKey={propsChart.line.dataKey}
            stroke={propsChart.line.color}
            strokeWidth={2}
            dot={{ r: 4 }}
            label={(props) => {
              const { x, y, value } = props
              return (
                <g>
                  <foreignObject x={x - 25} y={y - 20} height={18} width={50}>
                    <Element
                      style={{
                        fontSize: 10,
                        height: '100%',
                        width: '100%',
                        textAlign: 'center',
                        fontWeight: 400,
                      }}
                    >
                      {formatVal(value * 100, locale, undefined) + '%'}
                    </Element>
                  </foreignObject>
                </g>
              )
            }}
          />
        </ChartContainer>
      </div>
      <div className="h100 w25 dFlex alignItemsCenter justifyContentCenter pl1">
        <div>
          <Element style={{ color: propsChart.labelTopColor }}>
            <Translate value="financialAnalysis.COMPANY" />
          </Element>
          <Element
            className="mt2"
            style={{ color: propsChart.labelBottomColor }}
          >
            <Translate value="financialAnalysis.INDUSTRY_AVG" />
          </Element>
        </div>
      </div>
    </div>
  )
}

export default ChartRight
